<script>
	import { Router, Route } from "svelte-navigator";
	import { initClient } from '@urql/svelte';

	initClient({
		//url: isProduction ? 'https://admin.jetnoise.ch/api' : 'https://admin.jetnoise.stumi/api',
		url: 'https://admin.jetnoise.ch/api',
		/*fetchOptions: () => {
			const token = getToken();
			return {
				headers: { Authorization: token ? `Bearer ${token}` : '' },
			};
		},*/
	});
	function getToken() {
		return "QUO9D-iQrRbGN-Sb5Dz-qGMbcYJUAaBK";
	}

	import Header from "./header.svelte"
	import Footer from "./footer.svelte"
	import Home from "./home.svelte"
	import AirshowDetail from "./airshowDetail.svelte"
	import AirshowOverview from "./airshowOverview.svelte"
	import Galleries from "./galleries.svelte"
	import MyChoice from "./myChoice.svelte"
	import About from "./about.svelte"


</script>

<Router>
	<Header/>
	<Route path="/" component={Home} />
	<Route path="airshows/" component={AirshowOverview} />
	<Route path="airshows/*airshowRoute" component={AirshowDetail} />
	<Route path="galleries/" let:location component={Galleries} />
	<Route path="mychoice" component={MyChoice} />
	<Route path="about" component={About} />
	<Route>
		<h3>404</h3>
		<p>No Route could be matched.</p>
	</Route>
	<Footer/>
</Router>